/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=dd89407a&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "./tab.vue?vue&type=style&index=0&id=dd89407a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd89407a",
  null
  
)

export default component.exports